import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import ppUtilities from '../ppUtilities';
import CartHelper from '../CartHelper';
import BundlesFlyoutComponent from './BundlesFlyoutComponent';

// This component is the application entry point

const _cartHelper = new CartHelper();

class CartConfirmation extends Component {
	constructor(props) {
		super(props);
		this.eCart = null;
	}

	componentDidUpdate() {
		if (!Array.isArray(this.props.initCardData) && Array.isArray(this.props.cart)) {
			const { initCardData } = this.props;

			let istApiUrl = initCardData.istApiUrl;
			let cartId = _cartHelper.getCartId();
			if (cartId != undefined) {
				this.props.getCartState(cartId, istApiUrl);
			} else {
				if (_cartHelper.isUserLoggedIn()) {
					this.props.getCartIdFromUser(istApiUrl);
				}
			}
		}
	}

	render() {
		let { addedBundle } = this.props;
		if (!Array.isArray(addedBundle)) {
			return <BundlesFlyoutComponent />;
		}
		return null;
	}
}

function mapStateToProps({ cartState, initCardData, cart, addedBundle }) {
	return {
		cartState,
		initCardData,
		cart,
		addedBundle,
	};
}

export default connect(mapStateToProps, actions)(CartConfirmation);
